import { createAsyncThunk } from '@reduxjs/toolkit';
import Api from '../../api';

export const getArticle = createAsyncThunk('getArticle/getArticle', async (payload, thunkAPI) => {
  try {
    const { data } = await Api.getSingleArticle(payload.id);
    return data;
  } catch (e) {
    return thunkAPI.rejectWithValue(e.response.data);
  }
});
